import { useState } from "react";
import { BoldifyReplace } from "./BoldifyReplace";
import ActionTracker from "./ActionTracker";

const legendString = [ 
    {replaceValue: "{@b Hit: +5 +2d6 Cool Effect}", note: "Bold"},
    {replaceValue: "{@i Very Fancy}", note: "Italics"},
];

const hoverableStrings = [ 
    {replaceValue: "{@hover light}", note: "Spells"}, 
    {replaceValue: "{@hover PrOnE}", note: "Conditions"},       
];

const SyntaxLegendPopup = () => {
    const [actionsCount, setActionsCount] = useState(42);

    const handleExampleCheck = (add) => {
        if(add) {
            setActionsCount(c => c+1)
        } else {
            setActionsCount(c => c-1)
        }
    }

    return (
        <div className="syntaxLegendPopupContainer">
            <hr className="editlineSeperator"/>
            <h4 style={{margin: '0px 0px 2px 0px'}}>Syntax Legend</h4>
            <span style={{color: 'black', fontSize: 'smaller'}}>Use this syntax just about anywhere to get extra fancy in your Homebrew Statblocks!</span>
            <span style={{color: 'black', fontSize: 'smaller'}}><i>Case Insensitive - Correct Spelling Required for Hoverable Popups (duh)</i></span>
            <div  className="syntaxLegendPopup" 
                style={{display: 'grid', gridTemplateColumns: '.5fr .7fr 1fr', gap: '2px 0px', alignItems: 'center', marginBottom: '8px', fontSize: '14px'}}
            >
                <b style={{color: 'black'}}>Type</b>
                <b style={{color: 'black'}}>Satblock Effect</b>
                <b style={{color: 'black'}}>Syntax</b>
                <hr className="editlineSeperator" />
                <hr className="editlineSeperator" />
                <hr className="editlineSeperator" />
                <span style={{gridColumn: '1 / 4'}}><b><i>Popups</i></b> - The 'Spells' and 'Conditions' Search Tabs contain all Hoverable Popups</span>
                {hoverableStrings.map((stringObj, i) => (
                    <div key={i} style={{display: 'contents'}}>
                        <div style={{color: 'black'}}>{stringObj.note}</div>
                        <div><BoldifyReplace desc={stringObj.replaceValue}/></div>
                        <div style={{color: 'black'}}>{stringObj.replaceValue}</div>
                    </div>
                ))}
                <hr className="editlineSeperator" />
                <hr className="editlineSeperator" />
                <hr className="editlineSeperator" />
                <span style={{gridColumn: '1 / 4'}}><b><i>Non-Popups</i></b></span>
                {legendString.map((stringObj, i) => (
                    <div key={i} style={{display: 'contents'}}>
                        <div style={{color: 'black'}}>{stringObj.note}</div>
                        <div><BoldifyReplace desc={stringObj.replaceValue}/></div>
                        <div style={{color: 'black'}}>{stringObj.replaceValue}</div>
                    </div>
                ))}
                <div style={{color: 'black'}}>Slot Tracker</div>
                <div style={{display: 'flex', alignItems: 'center'}}> <b style={{color: 'black'}}>Title</b> <ActionTracker actions_count={actionsCount} handleCheck={handleExampleCheck}/> </div>
                <div style={{color: 'black'}}>(4/Day) <i style={{fontSize: '11px'}}> - Titles only</i></div>
            </div>
            <span style={{color: 'black', fontSize: 'smaller', width: '90%', marginBottom: '5px'}}><i><b>Popup</b> options not listed - <b>{'{@spell xyz} {@disease xyz} {@status xyz} {@condition xyz}'}</b> - are treated as <b>{'{@hover xyz}'}</b></i></span>
            <span style={{color: 'black', fontSize: 'smaller', width: '90%', marginBottom: '5px'}}><i>Any unlisted <b>Non-Popup</b> option - i.e. <b>{'{@hit}'}</b> - are <b>bolded</b> as Words of Interest and treated as <b>{'{@b xyz}'}</b></i></span>
        </div>
    );
};

export default SyntaxLegendPopup;